import { render, staticRenderFns } from "./UserAddresses.vue?vue&type=template&id=d197cbd8&scoped=true"
import script from "./UserAddresses.vue?vue&type=script&lang=js"
export * from "./UserAddresses.vue?vue&type=script&lang=js"
import style0 from "./UserAddresses.vue?vue&type=style&index=0&id=d197cbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d197cbd8",
  null
  
)

export default component.exports